import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ErrorsComponent } from './errors/errors.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ReviewComponent } from './review/review.component';
import { LayoutComponent } from './layout/layout.component';
import { DocumentsComponent } from './documents/documents.component';
import { PacComponent } from './pac/pac.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AppModule } from './app.module';


export const routes: Routes = [   
    {
        path: '', component: LayoutComponent,
        children: [
            { path: 'home/:uniquetoken', component: DocumentsComponent },
            { path: 'pac/:uniquetoken', component: PacComponent },
            { path: 'review/:uniquetoken', component: ReviewComponent }
        ]
    },
    { path: 'confirm/:status/:uniquetoken', component: ConfirmationComponent },
    { path: 'errors', component: ErrorsComponent },
    { path: 'maintenance', component: MaintenanceComponent }
];

export const AppRoutes: ModuleWithProviders<AppModule> = RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' });
